/* istanbul ignore file */
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { IPromoSlot } from 'src/app/model/promos/IPromoSlot';
import { UtilityService } from '../../../core/services/utility.service';
import { ChatHandler } from 'src/app/core/handler/chat-handler';
import { ADPResourceService } from 'digital-core';
import { AsappChatService } from '../../../core/services/asapp-chat.service';
import { StorageService } from '../../../core/services/storage.service';

@Component({
  selector: 'app-promotion-panel',
  templateUrl: './promotion-panel.component.html',
  styleUrls: ['./promotion-panel.component.scss'],
})
export class PromotionPanelComponent implements OnInit {
  @Input() promoSlot: IPromoSlot;
  @Input() isPTPO: boolean = false;
  @Input() isDisabledController: boolean;
  @Input() gaName;
  @Input() divider = false;
  @Input() isPromoBackFill?: boolean = false;
  @Input() productTemplate?: string;


  @Output() letsChatClicked = new EventEmitter();

  public imageKeyMobileUrl: string = '';
  public imageKeyMobileAlt: string = '';

  hasP360MobilePolicy = false;
  hasP360HomeTechPolicy = false;

  constructor(
    private matDialog: MatDialog,
    public route: ActivatedRoute,
    private utilityService: UtilityService,
    private resourceService: ADPResourceService,
    private asappChatService: AsappChatService,
    private storageService: StorageService,
  ) {}

  ngOnInit() {
    this.imageKeyMobileUrl = this.resourceService.getPortalImage('Global_TechServices_Promo_People_Mobile_ImageKey').ImageURL;
    this.imageKeyMobileAlt = this.resourceService.getPortalImage('Global_TechServices_Promo_People_Mobile_ImageKey').Caption;
    this.hasP360MobilePolicy = this.storageService.getLocal<string>(`EprismContractsCount`) > '0';
    this.hasP360HomeTechPolicy = this.storageService.getLocal<string>(`ElitaContractsCount`) > '0';
  }

  getResource(name: string, namespace = null) {
    namespace = namespace ? namespace : 'Promo';
    let title = namespace + '_' + name;
    let resourceValue = this.resourceService.getViewResourceObject(title);
    return resourceValue;
  }

  letsChat() {
    this.letsChatClicked.emit();
    const rnWindow = window as any;
    if (rnWindow.ReactNativeWebView) {
      const message = JSON.stringify({ action: 'openChat', args: {} });
      rnWindow.ReactNativeWebView.postMessage(message);
    }

    // Show chat or not available dialog
    const chatHandler = new ChatHandler(this.matDialog, this.resourceService, this.utilityService, this.route, this.asappChatService);
    if (this.productTemplate === 'mobile') {
      chatHandler.openChatInterface(true, false);
    } else if (this.productTemplate === 'home') {
      chatHandler.openChatInterface(false, true);
    } else {
      chatHandler.openChatInterface(this.hasP360MobilePolicy, this.hasP360HomeTechPolicy);
    }
  }
}
